import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, ADD, EDIT, DELETE, OPEN } from "const"
import { okrKeyResultsRoute } from "client/parts/routes"
import { hasAccess } from "client/utils"
import {
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    StoreType,
    IsOwnerOkrObjective,

    setOkrObjectivePopupMenuShow,
    setOkrObjectiveShowConfirmDelete,
    addModal,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

const Menu = () => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)

    const objectiveBaseRoute = useSelector((state: StoreType) => state.okrObjective.baseRoute)
    const objectiveRoute = useSelector((state: StoreType) => state.okrObjective.objectiveRoute)
    const activeObjective = useSelector((state: StoreType) => state.okrObjective.active)
    const menuShow = useSelector((state: StoreType) => state.okrObjective.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.okrObjective.menuTarget)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const hideMenu = () => {
        dispatch(setOkrObjectivePopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const viewAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, VIEW)
    const addAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, ADD)
    const editAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, EDIT)
    const deleteAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, DELETE)

    if (!activeObjective) return null

    const isOwnerObjective = IsOwnerOkrObjective(activeObjective, userData.userId)
    const isOwnerSession = session.owner === userData.userId
    const isOwner = isOwnerObjective || isOwnerSession

    const isOpenSession = session.status === OPEN

    const baseRoute = `${objectiveBaseRoute}${objectiveRoute}`
    const viewUrl = `${baseRoute}/${VIEW}/${activeObjective.id}`
    const editUrl = `${baseRoute}/${EDIT}/${activeObjective.id}`
    const addKeyResultUrl = `${baseRoute}/${VIEW}/${activeObjective.id}${okrKeyResultsRoute}/${EDIT}/0`
    const addChildObjectiveUrl = `${baseRoute}/${EDIT}/0?parentObjectiveId=${activeObjective.id}`

    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {
                (viewAccess || isOwner)
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: viewUrl }))}>
                        {lang.details}
                    </PopupMenuItem>
                )
            }
            {
                (editAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: editUrl }))}>
                        {lang.edit}
                    </PopupMenuItem>
                )
            }
            {
                (addAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: addKeyResultUrl }))}>
                        {lang.addKeyResult}
                    </PopupMenuItem>
                )
            }
            {
                (addAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: addChildObjectiveUrl }))}>
                        {lang.addChildObjective}
                    </PopupMenuItem>
                )
            }
            <PopupMenuItem>
                {lang.clone}
                TODO
            </PopupMenuItem>
            {
                // TODO: when select target to move into, check also (editAccess || isOwnerObjective || isOwnerSession) for the target
                (editAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem>
                        {lang.move}
                        TODO
                    </PopupMenuItem>
                )
            }
            {
                (deleteAccess || isOwner)
                && isOpenSession
                && (
                    <PopupMenuItem onClick={() => dispatch(setOkrObjectiveShowConfirmDelete(true))}>
                        {lang.delete}
                    </PopupMenuItem>
                )
            }
        </PopupMenu>
    )
}

export default Menu
